module.exports = __webpack_public_path__ + "img/img9.5e092e70.svg";